import Backbone from 'backbone';

import { FulfillmentMethodHelper, KioskPreviewMode, OrderChannel } from '@biteinc/enums';

import { BrowserHelper } from '../helpers/browser_helper';
import { makeKioskPreviewUrl } from '../helpers/make_kiosk_preview_url';
import { template } from '../template';

app.KioskPreviewView = Backbone.View.extend({
  className: 'field-container location-settings container-fluid kiosk-preview-view',
  template: template($('#kiosk-preview-view-template').html()),

  initialize(options) {
    this._previewName = options.previewName;
    this._showFlashDisclaimer = options.showFlashDisclaimer;
    this._forcedMenuStructureId = options.forcedMenuStructureId;
    this._fulfillmentMethods = options.fulfillmentMethods || [];
    this._displayLiveUrl = options.displayLiveUrl;
  },

  setFulfillmentMethods(fulfillmentMethods) {
    this._fulfillmentMethods = fulfillmentMethods;
    this.render();
  },

  render() {
    let flashUrl;
    let flashUrlsWithSessionToken = [];
    if (app.location.get('flashEnabled')) {
      flashUrl =
        app.location.getFlashUrl() +
        (this._forcedMenuStructureId
          ? `?forcedMenuStructureId=${this._forcedMenuStructureId}`
          : '');

      if (app.sessionUser.isBiteOps()) {
        if (app.externalAuthStrategy.hasBeenFetched()) {
          if (app.externalAuthStrategy.get('secretKey')) {
            flashUrlsWithSessionToken = app.location.getFlashUrlsWithSessionToken(
              app.externalAuthStrategy,
              this._forcedMenuStructureId,
            );
          }
        } else {
          this.listenToOnce(app.externalAuthStrategy, 'reset', this.render);
          app.externalAuthStrategy.fetch({ reset: true });
        }
      }
    }

    let showKioskFulfillmentWarning = true;
    let showFlashFulfillmentWarning = true;

    this._fulfillmentMethods
      .filter((fulfillmentMethod) => {
        return app.location.getDiningOption(fulfillmentMethod).isEnabled;
      })
      // Using "every" to short if one of the fulfillment methods fails the test
      .every((fulfillmentMethod) => {
        if (FulfillmentMethodHelper.isKiosk(fulfillmentMethod)) {
          showKioskFulfillmentWarning = false;
        } else {
          // If it's not a kiosk channel, then it's a flash-compatible channel
          showFlashFulfillmentWarning = false;
        }
        return showKioskFulfillmentWarning || showFlashFulfillmentWarning;
      });

    this.$el.html(
      this.template({
        kioskPreviewUrlLive:
          app.sessionUser.isAdmin() &&
          this._displayLiveUrl &&
          makeKioskPreviewUrl({
            previewMode: KioskPreviewMode.Live,
            forcedMenuStructureId: this._forcedMenuStructureId,
          }),
        kioskPreviewUrlDemo: makeKioskPreviewUrl({
          previewMode: KioskPreviewMode.Demo,
          forcedMenuStructureId: this._forcedMenuStructureId,
        }),
        flashUrl,
        flashUrlsWithSessionToken,
        previewName: this._previewName,
        canShowKioskPreview: [
          OrderChannel.DriveThru,
          OrderChannel.Kiosk,
          OrderChannel.Linebuster,
        ].includes(app.location.get('orderChannel')),
        showKioskFulfillmentWarning,
        showFlashFulfillmentWarning,
        showFlashDisclaimer: this._showFlashDisclaimer,
      }),
    );

    this.$('#copy-flash-url').on('click', () => {
      if (BrowserHelper.copyTextToClipboard(flashUrl)) {
        app.showSavedToast('Copied Flash Link to Clipboard!');
      }
    });

    return this;
  },
});
